import React, {PureComponent} from "react"
import styled from "styled-components"

import Card from "@irati/ui/src/Layout/Card"
import {FormattedMessage, injectIntl, InjectIntl} from "@irati/utils/lang"
import {greys} from "@irati/ui/src/global/colors"
import {Para} from "@irati/ui/src/Labels"
import {Hr} from "@irati/ui/src/Layout"

import Header from "../Detail/Header"
import customRewardImage from "../../images/customReward.png"

const StyledPara = styled(Para)`
  margin-top: 20px;
  color: ${greys.mediumDark};
`

interface Props extends InjectIntl {}

class Detail extends PureComponent<Props> {
  render() {
    const {formatMessage} = this.props
    return (
      <Card large>
        <Header
          title={formatMessage({id: "reward.customReward.title"})}
          thumbnailImage={customRewardImage} />
        <Hr large />
        <Para>
          <FormattedMessage id="reward.customReward.detail.description" />
        </Para>
        <StyledPara>
          <FormattedMessage id="reward.fields.reward.customReward.Hint" />
        </StyledPara>
      </Card>
    )
  }
}

export default injectIntl(Detail)
